<div class="progress-spinner" *ngIf="progressSpinnerService.spinner$ | async">
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="pacman" viewBox="0 0 400 200">
    <!-- In order to externalize, we have to put all the necessary styling inline here. -->
    <style>
      .pacman-dot {
        fill: white;
      }

      .pacman-open,
      .pacman-mouth-top,
      .pacman-mouth-bottom {
        fill: white;
      }
      .pacman-mouth-top,
      .pacman-mouth-bottom {
        animation-duration: 175ms;
        animation-timing-function: linear;
        animation-direction: alternate;
        animation-iteration-count: infinite;
        transform-origin: calc(300px / 2) 150px;
      }
      .pacman-mouth-top {
        animation-name: rotate-counterclockwise;
      }
      .pacman-mouth-bottom {
        animation-name: rotate-clockwise;
      }

      @keyframes rotate-counterclockwise {
        100% {
          transform: rotate(-30deg);
        }
      }
      @keyframes rotate-clockwise {
        100% {
          transform: rotate(30deg);
        }
      }

      .pacman-dot {
        animation-name: dot-motion;
        animation-duration: 600ms;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }

      @keyframes dot-motion {
        100% {
          transform: translateX(-100px);
        }
      }
    </style>
    <circle class="pacman-dot" cx="250" cy="70%" r="10" />
    <circle class="pacman-dot" cx="350" cy="70%" r="10" />
    <circle class="pacman-dot" cx="450" cy="70%" r="10" />
    <circle class="pacman-dot" cx="550" cy="70%" r="10" />
    <circle class="pacman-dot" cx="650" cy="70%" r="10" />
    <!-- Create an arc covering 45°, so there's a little overlap with an animation of 30° -->
    <path
      class="pacman-mouth-bottom"
      d="
            M 150,150
            L 220.4,221.0
            A 100 100 0 0 0 250,150
            Z"
    />
    <path
      class="pacman-mouth-top"
      d="
            M 150,150 
            L 220.4,79.0
            A 100 100 0 0 1 250,150
            Z"
    />
    <path
      class="pacman-open"
      d="
            M 150,150
            L 236.6,100
            A 100 100 0 1 0 236.6,200
            Z"
    />
  </svg>
</div>
